import { GameColor } from '@colonist/ui-game';
import { showRulebookPopup } from '../ui_rulebook/UIRulebookPopupGlobal.ts';
import { createDivIn, createExternalImgIn, createImgIn, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { UIChatPostText } from './UIChatPostText.ts';
import { UIUtilsChat } from './UIUtilsChat.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { uiGameManager } from '../EntryShared.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIChatPostController {
    createPostDiv() {
        const post = createDivIn(this.container, 'message-post', '');
        if (!(UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI)) post.style.color = this.isMessageSentInGame ? GameColor.getColor(this.textColorInGame) : GameColor.getColor(this.textColorInRoom);
        setElementOnClick(post, ()=>AudioManager.play(AudioType.Click));
        if (this.chatData.isCentered != true) return post;
        post.classList.add('victory-text');
        post.style.color = UIUtilsChat.getTextColor('' + this.chatData.username, GameColor.getColor(this.textColorInGame));
        return post;
    }
    setEventHandlersForHelpLinks() {
        const linkElements = this.post.getElementsByTagName('a');
        for (const link of linkElements){
            const url = new URL(link.href);
            if (url.hash == UIUtilsChat.OPEN_RULEBOOK_LINK_HASH) {
                setElementOnClick(link, ()=>{
                    uiGameManager.pauseController.pauseIfSinglePlayer();
                    showRulebookPopup();
                }, true, true);
                continue;
            }
        }
    }
    constructor(container, chatData){
        this.textColorInGame = GameColor.Color.Gray0;
        this.textColorInRoom = GameColor.Color.White;
        this.iconSize = 20;
        this.container = container;
        this.chatData = chatData;
        this.isMessageSentInGame = container.className.includes('game_chat');
        this.post = this.createPostDiv();
        if (chatData.profilePictureUrl) {
            const img = createExternalImgIn(this.post, chatData.profilePictureUrl, {
                key: 'strings:colonistCommon.utils.emptyString'
            });
            img.style.borderRadius = '50%';
            img.width = this.iconSize;
            img.height = this.iconSize;
        } else if (chatData.icon != undefined) {
            const img = createImgIn(this.post, chatData.icon);
            img.width = this.iconSize;
            img.height = this.iconSize;
        }
        const isLog = this.container.id == 'game-log-text';
        new UIChatPostText(this.post, this.chatData, this.textColorInGame, isLog);
        this.setEventHandlersForHelpLinks();
    }
}
